import $ from 'jquery';

$(document).ready(function() {
    var button = $('.js-add-link');

    if (button) {
        button.on('click', function (e) {
            var form = $(this).closest('form');
            if (form) {
                e.preventDefault();
                form.submit();
                $.ajax({
                    type: 'POST',
                    url: $(this).attr('href'),
                    success: function (data) {
                        console.log('success');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log('error');
                    }
                });
            }
        })
    }
});